import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
function Services() {
  return (
    <section id='services'>
      <h5>What I offer</h5>
      <h2>Services</h2>
      <div className='container services__container'>
        <article className="service">
<div className="service__head">
  <h3>facebook ads</h3>
  </div>
  <ul className='service__list'>
<li>
  <BiCheck className='service__list-icon'/>
  <p>professional facebook page builder.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>create facebook business manager.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>create site web with You ken.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>create ads on facebook & Tiktok.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>menager pages facebook.</p>
</li>
  </ul>

        </article>
        {/* END OF UI/UX */}
        <article className="service">
<div className="service__head">
  <h3>Web Development</h3>
  </div>
  <ul className='service__list'>
<li>
  <BiCheck className='service__list-icon'/>
  <p>develop web interfaces adapted to the needs of its client With React.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Small site management.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>create desktop application With Java.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>create mobile app With flutter.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Create backgrounds for websites.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Creat small website database.</p>
</li>
  </ul>

        </article>
        {/* WEB DEV */}

        <article className="service">
<div className="service__head">
  <h3>Content Creation </h3>
  </div>
  <ul className='service__list'>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Social Media Post Design.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Content Calendar Planning.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Caption and Hashtag Writing.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Video Storytelling.</p>
</li>
<li>
  <BiCheck className='service__list-icon'/>
  <p>Engagement and Community Management.</p>
</li>
  </ul>

        </article>
        {/* end of content creation  */}
        </div>
    </section>
  )
}

export default Services